<template>
  <div class="index">
    <!-- <div class="box"></div> -->
    <div class="over_h">
      <div class="allP open" @click="openBtn" v-show="open">全屏打开</div>
      <div class="allP exit" @click="openBtn" v-show="exit">退出全屏</div>
    </div>
    <div class="over_h ovDiv">
      <iframe id="iframe" src="http://publicMap.vmuyun.com/"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open:true,
      exit:false,
      fullscreen: false
    }
  },
  methods:{
    openBtn(){
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        }else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }else{
        if (element.requestFullscreen) {
          element.requestFullscreen();
        }else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        }else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
        // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
      this.open = !this.open
      this.exit = !this.exit
    },
    //exitBtn(){},
  },
  // 注册组件
  components: {

  },
  created() {

  },
}
</script>

<style scoped>
  .box{
    height:20px
  }
  .acopy{
    background: none;
  }
  .allP{
    position: fixed;
    right: 30px!important;
    background: #0F2733;
    height: 40px;
    line-height: 40px;
    width: 100px;
    text-align: center;
    font-size: 14px;
    color: #797979!important;
    border-radius: 5px;
    top: 90px;
    cursor: pointer;

  }
  .allP a{
    color: #797979!important;
  }
  .layui-layout-body.fullPage .layui-side.layui-bg-black,
  .layui-layout-body.fullPage .layui-header,
  .layui-layout-body.fullPage .acopy{
    display: none;
  }
  .layui-layout-body.fullPage .layui-layout-admin .layui-body{
    left: 0px;background: none;
    top:0 !important;bottom: 0;right:0;
  }
  .layui-layout-body.fullPage .layui-layout-admin .layui-body>div{
    padding: 0 !important;
  }
  .layui-layout-body.fullPage .layui-layout-admin .layui-body>div .ovDiv{
    height: 100vh !important;
  }
  .layui-layout-body.fullPage .allP{
    right:30px;top:40px;
    font-size:18px!important;
  }
  .ovDiv{
    width: 100%;height:calc( 100vh - 190px );
    overflow-y: auto;
  }
  .ovDiv::-webkit-scrollbar {/*隐藏滚轮*/
   display: none!important;
   opacity: 0;
  }
  #iframe{
    width: 100%;height:130%;border: none;
  }
  .ovDiv.ovDivWidth100{
    overflow-y: hidden!important;
  }

  .ovDiv.ovDivWidth99 #iframe{
    height:99%
  }
  .ovDiv.ovDivWidth100 #iframe{
    height:100%!important;
  }
  .aa{
    display: none;
  }

  /* .allP{
    border: 1px solid #e2e2e2;
    font-size: 16px;
    width: 80px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    text-align: center;
    position: absolute;
    right: 20px;
    background: #fff;
  }
  .allP a{
    float: none !important;
  } */

</style>



// WEBPACK FOOTER //
// src/views/datas/datas.vue